import { render, staticRenderFns } from "./jiankang.vue?vue&type=template&id=dc708e90&scoped=true&"
import script from "./jiankang.vue?vue&type=script&lang=js&"
export * from "./jiankang.vue?vue&type=script&lang=js&"
import style0 from "./jiankang.vue?vue&type=style&index=0&id=dc708e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc708e90",
  null
  
)

export default component.exports